export default __webpack_public_path__ + "img/download-dark.920f71c3.svg";